import { ClickAwayListener, Stack, Typography } from '@mui/material';
import { filterMenuItems } from '@treedis/tour-loader';
import classnames from 'classnames';
import _cloneDeep from 'lodash/cloneDeep';
import { Component, createRef } from 'react';
import { toast } from 'react-toastify';
import { TourType } from '@/_models/Tour';
import { Menu as MenuObject, MenuType } from '@/_models/Menu';
import { sendToGA } from '../../../util/analytic';
import DeviceManager from '../../../util/deviceManager';
import LeftMenuNav from './components/LeftMenuNav';
import MenuNav from './components/MenuNav';
import { fetchMenuData } from './menuService';
import { BookStyled, DivStyled, NavStyled, SearchSpanStyled } from './styled';

export default class Menu extends Component<any, any> {
  loadModel: any;

  menu: any;

  toggleContactPopup: any;

  toggleExternalPopup: any;

  closeMenu: any;

  inputSearch: any;

  constructor(props: any) {
    super(props);
    this.state = {
      menus: this.props.menus || [],
      menuSettings: this.props.menuSettings,
      originMenus: [],
      tourId: this.props.tourId,
      menuOpen: this.props.menuOpen,
      menuSearch: this.props.menuSearch,
      bookUrl: this.props.bookUrl,
      bookText: this.props.bookText,
      bookColor: this.props.bookColor,
      contact: this.props.contact,
      bookAppointment: this.props.bookAppointment,
      whitelabel: this.props.whitelabel,
      address: this.props.address,
      rtl: this.props.client && this.props.client.rtl,
      activeMenu: this.props.activeMenu,
      scrollTo: 0,
      currentSweep: this.props.currentSweep,
      deprecatedSweeps: this.props.deprecatedSweeps,
    };
    this.moveToMenuItem = this.moveToMenuItem.bind(this);
    this.toggleContactPopup = props.toggleContactPopup.bind(this);
    this.toggleExternalPopup = props.toggleExternalPopup.bind(this);
    this.closeMenu = props.closeMenu.bind(this);
    this.openMenu = this.openMenu.bind(this);
    this.inputSearch = createRef();
  }

  async componentDidMount() {
    const { menuCategoryExpand, menus } = this.props;

    if (menuCategoryExpand) {
      menus.forEach((menu) => {
        menu.open = !menu.open;
      });
    }

    this.setState({
      menus,
      originMenus: _cloneDeep(menus),
    });
  }

  static getDerivedStateFromProps(nextProps: any, prevState: any) {
    let { scrollTo } = prevState;
    if (!nextProps.menuOpen) scrollTo = 0;
    if (nextProps.menuOpen !== prevState.menuOpen) {
      const { menus } = prevState;
      const { activeMenu } = nextProps;
      if (activeMenu) {
        if (
          !prevState.activeMenu ||
          activeMenu.id !== prevState.activeMenu.id ||
          activeMenu.subMenu !== prevState.activeMenu.subMenu ||
          activeMenu.subSubMenu !== prevState.activeMenu.subSubMenu
        ) {
          if (activeMenu.id) {
            const i = menus.findIndex((m: any) => m.id === activeMenu.id);

            if (i >= 0) {
              menus[i].open = true;
              menus[i].isActive = true;
              scrollTo = (i + 1) * 33;

              if (activeMenu.subMenu) {
                const j = menus[i].subMenus.findIndex((m: any) => m.id === activeMenu.subMenu);
                if (j >= 0) {
                  menus[i].subMenus[j].open = true;
                  menus[i].subMenus[j].isActive = true;
                  scrollTo += (j + 1) * 33;
                } else {
                  toast.error('Menu item does not exist');
                }
              } else {
                Menu.resetMenus(menus[i].subMenus);
              }
            } else {
              toast.error('Menu item does not exist');
            }
          } else {
            Menu.resetMenus(menus);
          }
        }
      } else if (Menu.isHorizontalMobileView() && !nextProps.menuOpen) {
        Menu.resetMenus(menus);
      }
      return {
        menuOpen: nextProps.menuOpen,
        menus,
        activeMenu,
        scrollTo,
        contact: nextProps.contact,
      };
    }
    return { scrollTo };
  }

  static resetMenus(menus: any[]) {
    menus.map((m: any) => {
      m.open = false;
      if (m.subMenus) {
        m.subMenus = m.subMenus.map((sM: any) => {
          sM.open = false;
          return sM;
        });
      }
      return m;
    });
  }

  static isHorizontalMobileView() {
    return DeviceManager.isHorizontalMobileView();
  }

  openMenu(i: number, j: number | null = null) {
    let scrollTo = (i + 1) * 33;

    const { menus } = this.state;
    let menu = menus[i];
    if (!menu) {
      Menu.resetMenus(menus);
      return;
    }
    if (j != null) {
      menu = menu.subMenus[j];
      scrollTo += (j + 1) * 33;
    }
    // commenting this part out because this is not closing the opened nested menus, only opens them
    // if (Menu.isHorizontalMobileView()) {
    //   Menu.resetMenus(menus);
    //   if (menu.subMenuId) {
    //     const parent = menus.subMenus.find(({ id }) => id === menu.subMenuId);
    //     if (parent) parent.open = !parent.open;
    //   }
    //   if (menu.menuId) {
    //     const parent = menus.find(({ id }) => id === menu.menuId);

    //     if (parent) parent.open = !parent.open;
    //   }
    // }
    menu.open = !menu.open;
    this.setState({ menus, scrollTo });

    if (menu.title) {
      sendToGA('event', {
        eventCategory: 'Place',
        eventAction: 'click',
        eventLabel: menu.title,
        eventType: menu.type,
      });
    }
  }

  moveToMenuItem(menu: MenuObject) {
    const { moveToMPLabels, loadModel } = this.props;
    if (menu.type === MenuType.MatterportLabel || menu.type === MenuType.MatterportFloor) {
      moveToMPLabels(menu);
    } else {
      loadModel(menu.title, menu.url, menu.type, menu.tag, menu.panoramaId, menu.changeMinimap, menu.changePanorama, menu.iframeSettings, menu.changeReel);
    }
    if (Menu.isHorizontalMobileView()) {
      Menu.resetMenus(this.state.menus);
    }
  }

  async componentDidUpdate(prevProps: any) {
    if (this.state.menuOpen && this.menu && this.state.activeMenu) {
      this.menu.scrollTop = this.state.scrollTo - 33;
    }
    if (this.props.changeMenu && this.props.changeMenu !== prevProps.changeMenu) {
      const { menus, menuSettings } = await fetchMenuData(this.props.tourId);
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ menus, menuSettings, originMenus: _cloneDeep(menus) });
    }
  }

  onChangeSearch({ target }) {
    const searchStr = target.value.toLowerCase();
    this.setState({
      menus: filterMenuItems(this.state.originMenus, searchStr),
    });
  }

  getOpenClassName() {
    const { sbIsOpen, tourType } = this.props;
    if (tourType === TourType.ECommerce) {
      if (sbIsOpen) {
        return 'openWithSidebarMax';
      }
      return 'openWithSidebar';
    }
    return 'open';
  }

  handleClickAway = (ev) => {
    if (
      this.props.isEcommerce &&
      typeof ev.target?.className?.includes === 'function' &&
      !ev.target?.className?.includes('sb-openMenu') &&
      !ev.target?.querySelector('.sb-openMenu')
    ) {
      this.props.onClose();
    }
  };

  handleMouseLeave = () => {
    this.closeMenu();
  };

  public render() {
    const { rtl, menuOpen, whitelabel, menuSettings, bookColor, currentSweep, deprecatedSweeps } = this.state;
    const isRegularTour = this.props.tourType === TourType.Regular;

    return (
      <ClickAwayListener mouseEvent="onMouseUp" onClickAway={this.handleClickAway}>
        <NavStyled
          // openOnHover is currently implemented only for Regular tours
          onMouseLeave={menuSettings?.openOnHover && isRegularTour ? this.handleMouseLeave : null}
          className={classnames(
            this.props.tourType === TourType.ECommerce && 'insideEcommerce',
            menuOpen && this.getOpenClassName(),
            rtl && 'rtl',
            DeviceManager.isHorizontalMobileView() && 'horizontal-modile-menu-view',
          )}
          menuBgColor={menuSettings?.menuBgColor}
        >
          {this.state.bookUrl && this.state.bookText && (
            <BookStyled
              color={bookColor}
              hoverColor={menuSettings?.bookActiveColor}
              textColor={menuSettings?.bookTxtColor}
              onClick={() => {
                sendToGA('event', {
                  eventCategory: 'Book Now',
                  eventAction: 'click',
                });
              }}
              id="book"
              rel="noreferrer"
              target="_blank"
              href={this.state.bookUrl}
            >
              {this.state.bookText}
            </BookStyled>
          )}
          {this.state.menuSearch && (
            <div className={classnames('menu-search-container', rtl && 'rtl')}>
              <input
                type="text"
                className="form-control"
                onChange={this.onChangeSearch.bind(this)}
                placeholder={(this.props.translation && this.props.translation.searchMenu) || 'Search...'}
                ref={this.inputSearch}
              />
              <i
                className="fas fa-times"
                onClick={() => {
                  this.onChangeSearch({ target: { value: '' } });
                  this.inputSearch.current.value = '';
                }}
              />
              <SearchSpanStyled className="input-group-text" color={menuSettings?.searchButtonColor}>
                <i className="fas fa-search" />
              </SearchSpanStyled>
            </div>
          )}

          <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ color: '#fff' }} px={2}>
            <Typography variant="h6">{this.props.translation && this.props.translation.menu}</Typography>
          </Stack>

          {Menu.isHorizontalMobileView() && (
            <LeftMenuNav
              menus={this.state.menus}
              menuSettings={menuSettings}
              openMenu={this.openMenu}
              loadModel={this.moveToMenuItem}
              menuOpen={menuOpen}
              menuRef={(el: any) => {
                this.menu = el;
              }}
              resetMenus={(menus) => this.setState({ menus })}
              currentSweep={currentSweep}
              deprecatedSweeps={deprecatedSweeps}
            />
          )}
          {!Menu.isHorizontalMobileView() && (
            <MenuNav
              menus={this.state.menus}
              menuSettings={menuSettings}
              rtl={rtl}
              openMenu={this.openMenu}
              loadModel={this.moveToMenuItem}
              resetMenus={(menus) => this.setState({ menus })}
              menuRef={(el: any) => {
                this.menu = el;
              }}
              currentSweep={currentSweep}
              deprecatedSweeps={deprecatedSweeps}
            />
          )}

          {this.state.bookAppointment && (
            <div className="appointmentButton" onClick={this.props.toggleAppointmentsModal}>
              <i className="far fa-calendar-alt" />
              {this.props.translation && this.props.translation.bookAppointment}
            </div>
          )}

          {this.state.contact && (
            <DivStyled
              color={bookColor}
              hoverColor={menuSettings?.bookActiveColor}
              textColor={menuSettings?.bookTxtColor}
              className="contactButton"
              onClick={this.props.toggleContactPopup}
            >
              <i className="fas fa-mobile" /> {this.props.translation && this.props.translation.getInTouch}
            </DivStyled>
          )}

          <div className={rtl ? 'rtl contact' : 'contact'}>
            {this.state.address && (
              <span
                onClick={() => {
                  this.toggleExternalPopup(
                    this.state.tourId === 5238 // This is magic number, TODO: create a feature out of this. quick fix.
                      ? 'https://www.skoda.co.il/show-rooms'
                      : `https://www.google.com/maps/embed/v1/place?key=AIzaSyAxJYg1iR0WMy4vpFa3zB7E0Dx7lz8h5dk&q=${this.state.address}`,
                  );
                  sendToGA('event', {
                    eventCategory: 'Contact',
                    eventAction: 'click',
                    eventLabel: 'map',
                  });
                }}
              >
                <i className="fas fa-map-marker-alt" />
                {this.state.address}
              </span>
            )}
            <h5>
              {this.props.translation && this.props.translation.producedBy}{' '}
              <a rel="noreferrer" target="_blank" href={whitelabel?.website}>
                <img src={whitelabel?.logo} alt="" />
              </a>
            </h5>
          </div>
        </NavStyled>
      </ClickAwayListener>
    );
  }
}
